<svg-icon src="assets/images/icons-svg/{{ icon }}.svg" [svgStyle]="svgStyle || null"></svg-icon>
